import { configureProductDucks } from 'axp-product-ducks';
import { configureProductDucks as configureProductDucksV1 } from '@americanexpress/product-ducks';

const getToState = (state) => state.getIn(['modules', 'axp-card-member-apply-root', 'products']);

const memberProducts = () => {
  configureProductDucks({
    getToState,
  });
  configureProductDucksV1({
    getToState,
  });
};

export default memberProducts;
